import { Component, OnInit, Input, ChangeDetectorRef, ElementRef, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

import { SiteNavNewEnum } from '@fs/enums/site-nav-new';
import { BodyBoxState } from '@fs/enums/body-box-state';
import { Tabs } from '@enums/tab.enum';
import { ActionName } from '@shared/enums/action-name';
import { CustomerService } from '@fs/services/customer';
import { TabOpenService } from '@services/tab-open.service';
import { CommonService } from '@shared/services/common';
import { AuthService } from '@services/auth.service';
import { CommonMethods } from '@services/common.method';
import { BillingDetailModel, PaymentTermModel } from '@fs/models/customer/billing-detail.model';
import { JobSiteDetailModel } from '@fs/models/customer/job-site-detail-model';
import { ContactInfoModel } from '@fs/models/customer/contact.info.model';
import { PermissionPipe } from '@shared/pipes/permission';

import { ToastrService } from 'ngx-toastr';
import { NotificationsService } from '@shared/services/notification';
import { Subscription } from 'rxjs';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
declare var google;
@Component({
  selector: 'customer-create',
  templateUrl: './cust-create.component.html',
  styleUrls: ['./cust-create.component.scss'],
  providers: [CustomerService]
})

export class FsLiteCustomerCreateComponent implements OnInit {

  //#region Input/Output
  @Input('popupMode') popupMode: boolean;
  @Input() copyJobSiteInfo: any = { firstname: true, lastname: true };
  @Output('saveResult') saveResult = new EventEmitter();
  //#endregion

  //#region Variable Declarations
  public isUnsavedTriggered: boolean = false;
  public HiddenSidePills: SiteNavNewEnum[] = [];
  /**used for adding class to div based on number */
  public mode: number = 0;
  public expandedBox: SiteNavNewEnum[] = [SiteNavNewEnum.BillingContact, SiteNavNewEnum.BillingDetails, SiteNavNewEnum.ContactInformation, SiteNavNewEnum.SiteInformation];
  public bodyBoxState = BodyBoxState;
  public siteNavNewEnum = SiteNavNewEnum;
  public initialData: any;
  public newCustomerForm: FormGroup;
  public tabCounter: number;
  public actionName = ActionName;
  public hasWorkOrderCreatePermission: boolean = true;

  private destroyTab: boolean = false;
  private valueChangeSubscription: Subscription;
  //#endregion

  //#region Constructor
  constructor(
    private toastr: NotificationsService,
    private frmbuilder: FormBuilder,
    private httpCustomer: CustomerService,
    private commonMethods: CommonMethods,
    private httpCommon: CommonService,
    private changeDetector: ChangeDetectorRef,
    private auth: AuthService,
    private tabopen: TabOpenService,
    private permissionPipe: PermissionPipe,
    private elementRef: ElementRef,
    private commonMethod:CommonMethods,
    private showspinner: SpinnerService,
    private viewContainerRef: ViewContainerRef
  ) {
    this.httpCommon.GetIntialData(this.auth.getCompanyId(), "Plan,ServiceAreas,Users,PaymentTerms,TaxGroups,LeadSources,JobSiteClasses, CodeTypeData").subscribe(
      response => {
        this.initialData = response;
      }
    )
    this.CreateForm();
    this.tabopen.ConfirmDestroyTabEvent.subscribe(response => {
      if (response.tabCounter == this.tabCounter) {
        this.destroyTab = true;
        this.CreateCustomer(false)
      }
    })
    this.newCustomerForm.controls['siteForm'].get('ZipCode').valueChanges.subscribe(() => {
      this.changeDetector.detectChanges();
    })
    this.newCustomerForm.controls['BillingDetailsForm'].get('ZipCode').valueChanges.subscribe(() => {
      this.changeDetector.detectChanges();
    })
  }
  //#endregion

  //#region Lifecycle Events
  ngOnInit() {
    this.hasWorkOrderCreatePermission = this.permissionPipe.transform(ActionName.NewWorkOrder);
  }

  ngOnChanges() {
    if (this.popupMode != undefined) {
      if (this.popupMode) {
        this.mode = 1;
      }
    }
  }

  ngDoCheck() {
    if (!this.isUnsavedTriggered) {
      let isDirty = this.newCustomerForm.dirty;
      if (isDirty) {
        this.isUnsavedTriggered = true;
        this.tabopen.unsavedChangedDetected({ dirty: isDirty, Index: this.tabCounter });
      }
    }
  }

  //#endregion

  //#region Methods

  public CopyTriggered(data){
    if(data["isCopy"]===true){
      const billingForm=(<FormGroup>this.newCustomerForm.get("BillingDetailsForm"));
      const siteForm=(<FormGroup>this.newCustomerForm.get("siteForm"));
      billingForm.controls["FirstName"].patchValue(siteForm.controls["FirstName"].value);
      billingForm.controls["LastName"].patchValue(siteForm.controls["LastName"].value);
      billingForm.controls["CompanyName"].patchValue(siteForm.controls["CompanyName"].value);
      billingForm.controls["Type"].patchValue(Object.assign({}, { ID: siteForm.controls["Type"].value, Code: "", Name: "" }));
      billingForm.controls["DisplayName"].patchValue(siteForm.controls["DisplayName"].value);
      billingForm.controls["StreetNo"].patchValue(siteForm.controls["StreetNo"].value);
      billingForm.controls["Unit"].patchValue(siteForm.controls["Unit"].value);
      billingForm.controls["City"].patchValue(siteForm.controls["City"].value);
      billingForm.controls["State"].patchValue(siteForm.controls["State"].value);
      billingForm.controls["ZipCode"].patchValue(siteForm.controls["ZipCode"].value);      
    }    
  }

  public ToggleBoxes(data: any) {
    this.expandedBox = [];
    let me = this;
    setTimeout(() => {
      if (data.constructor === Array) {
        me.expandedBox = data;
        setTimeout(() => {
          if ($(me.elementRef.nativeElement).find('input.ng-invalid,select.ng-invalid,input.custom-invalid').first().offset().top < 90)
            $("#mainContainer").scrollTop($("#mainContainer").scrollTop() - 90);
          let ng_elements = $(me.elementRef.nativeElement).find('input.ng-invalid,select.ng-invalid').first();
          if(ng_elements.length > 0){
            ng_elements.focus();
          } else {
            let cust_elements = $(me.elementRef.nativeElement).find('input.custom-invalid').first();
            if(cust_elements.val() == "")
              cust_elements.focus();            
          }
        }, 500);
      }
      else {
        me.expandedBox.push(data);
      }
    }, 200);

  }

  /**
   * @remarks Method to create a customer
   * @param IsNewWorkOrder 
   */
  private GetLatitude_Longitude(StreetNo:string,state:string,postalCode:string)
  {
    return new Promise(function(resolve, reject) {
     var result=[];
     var geocoder = new google.maps.Geocoder();
     var address = StreetNo;
     geocoder.geocode({'address': address ,'componentRestrictions': {
      'postalCode': postalCode
  }}, function (results, status) {
         if (status == google.maps.GeocoderStatus.OK) {
             var latitude = results[0].geometry.location.lat();
             var longitude = results[0].geometry.location.lng();
             result.push(latitude.toString());
             result.push(longitude.toString());
             resolve(result);
         }
         else
         {
          result.push('0');
          result.push('0');
          resolve(result);
         }
     })
    });
  }
  public async CreateCustomer(IsNewWorkOrder: Boolean) {
    if (this.newCustomerForm.valid) {
      this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
      let submitValues = Object.assign({}, this.newCustomerForm.value);
      let submitModel: BillingDetailModel = new BillingDetailModel();
      let paymentTerm: PaymentTermModel = new PaymentTermModel();
      let jobSiteContactModel: ContactInfoModel = new ContactInfoModel();
      let billingContactModel: ContactInfoModel = new ContactInfoModel();

        submitModel.IsActive = true;
        submitModel.ID =CommonMethods.GetID();
        submitModel.ModifyDate = "0001-01-01";

      if (submitValues.BillingDetailsForm.IsDefaultFromJobsite) {
        submitModel.FirstName = submitValues.siteForm.FirstName;
        submitModel.LastName = submitValues.siteForm.LastName;
        submitModel.CompanyName = submitValues.siteForm.CompanyName;
        submitModel.Type = Object.assign({}, { ID: submitValues.siteForm.Type, Code: "", Name: "" });
        submitModel.DisplayName = submitValues.siteForm.DisplayName;
        submitModel.StreetNo = submitValues.siteForm.StreetNo;
        submitModel.Unit = submitValues.siteForm.Unit;
        submitModel.City = submitValues.siteForm.City;
        submitModel.State = submitValues.siteForm.State;
        submitModel.ZipCode = submitValues.siteForm.ZipCode;
        submitModel.IsSameAsJobSite = true;
      } else {
        submitModel.FirstName = submitValues.BillingDetailsForm.FirstName;
        submitModel.LastName = submitValues.BillingDetailsForm.LastName;
        submitModel.CompanyName = submitValues.BillingDetailsForm.CompanyName;
        submitModel.Type = Object.assign({}, { ID: submitValues.BillingDetailsForm.Type, Code: "", Name: "" });
        submitModel.DisplayName = submitValues.BillingDetailsForm.DisplayName;
        submitModel.StreetNo = submitValues.BillingDetailsForm.StreetNo;
        submitModel.Unit = submitValues.BillingDetailsForm.Unit;
        submitModel.City = submitValues.BillingDetailsForm.City;
        submitModel.State = submitValues.BillingDetailsForm.State;
        submitModel.ZipCode = submitValues.BillingDetailsForm.ZipCode;
        submitModel.IsSameAsJobSite = false;
      }

      paymentTerm.ID = submitValues.BillingDetailsForm.PaymentTerm;
      submitModel.PaymentTerm = paymentTerm;
      submitModel.CustomerSince = submitValues.BillingDetailsForm.CustomerSince;

        submitModel.BillingID =CommonMethods.GetID();
      submitModel.Division = null;
      submitModel.Estimator = null;
      submitModel.AccountRep = null;
      submitModel.LeadSource = null;
      submitModel.IsCreditHold = false;
      submitModel.IsNoTransfer = false;
      submitModel.IsPoRequired = false;
      submitModel.LeadSourceComment = "";
      submitModel.LeadSourceEmployee = null;

      /* Billing Contact Validation*/
      if(!this.commonMethods.IsContactModelEmptyOrNull(submitValues.BillingContactForm)){
        let validationModel = { IsValid: true, Error: ""};
        if(submitValues.BillingContactForm.FirstName == ""){
          validationModel.IsValid = false;
          validationModel.Error = "First Name is required.\r\n";
        }    
        if(submitValues.BillingContactForm.PhoneNumber == ""){
          validationModel.IsValid = false;
          validationModel.Error += "Phone Number is required.";
        }  
        if(!validationModel.IsValid){
          this.OnSubmitError(false);
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
          this.toastr.showMultiLineError(validationModel.Error,"Error");
          return false;
        }
        billingContactModel.FirstName = submitValues.BillingContactForm.FirstName;
        billingContactModel.LastName = submitValues.BillingContactForm.LastName;
        billingContactModel.IsPrimary = true;
        billingContactModel.PhoneNumbers = [Object.assign({}, { PhoneNumber: submitValues.BillingContactForm.PhoneNumber, Type: { ID: submitValues.BillingContactForm.Type, Code: "", Name: "" }, IsDirty: false, ID: "", Description: submitValues.BillingContactForm.PhoneDescription, IsUsedForSMS: true })];
        billingContactModel.Emails = submitValues.BillingContactForm.EmailAddress == "" ? null : [Object.assign({}, { EmailAddress: submitValues.BillingContactForm.EmailAddress, IsDirty: false, ID: "", Description: submitValues.BillingContactForm.EmailDescription, IsUsedForEmail: true })];
        submitModel.Contacts[0] = billingContactModel;
      } else {
        submitModel.Contacts = null;
      }
      submitModel.Comment = submitValues.BillingDetailsForm.Comment;

      submitModel.JobSites = [Object.assign({}, submitValues.siteForm)];
      submitModel.JobSites[0].Type = Object.assign({}, { ID: submitValues.siteForm.Type, Code: "", Name: "" })
      submitModel.JobSites[0].ServiceArea = null;
      submitModel.JobSites[0].TaxGroup = { ID: submitValues.siteForm.TaxGroup }
      submitModel.JobSites[0].Comment = submitValues.siteForm.Comment;
      submitModel.JobSites[0].SiteClass = null;
      // find latitude and longitude again to cross verify
      const Coordinates = await this.GetLatitude_Longitude(submitModel.JobSites[0].StreetNo,submitModel.JobSites[0].State,submitModel.JobSites[0].ZipCode);
      
      submitModel.JobSites[0].Latitude = Coordinates[0];
      submitModel.JobSites[0].Longitude = Coordinates[1];

      jobSiteContactModel.FirstName = submitValues.ContactForm.FirstName;
      jobSiteContactModel.LastName = submitValues.ContactForm.LastName;
      jobSiteContactModel.IsPrimary = true;
      jobSiteContactModel.PhoneNumbers = [Object.assign({}, { PhoneNumber: submitValues.ContactForm.PhoneNumber, Type: { ID: submitValues.ContactForm.Type, Code: "", Name: "" }, IsDirty: false, ID: "", Description: submitValues.ContactForm.PhoneDescription, IsUsedForSMS: true })];
      jobSiteContactModel.Emails = submitValues.ContactForm.EmailAddress != "" ? [Object.assign({}, { EmailAddress: submitValues.ContactForm.EmailAddress, IsDirty: false, ID: "", Description: submitValues.ContactForm.EmailDescription, IsUsedForEmail: true })] : null;
      submitModel.JobSites[0].Contacts = [Object.assign({}, jobSiteContactModel)];

      this.httpCustomer.CreateCustomer(submitModel).subscribe(response => {
        if ($(this.elementRef.nativeElement).find('.tabs__content__box').hasClass('dirty')) {
          $(this.elementRef.nativeElement).find('.tabs__content__box').removeClass('dirty');
        }
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        this.toastr.success("Customer " + (<FormGroup>this.newCustomerForm.controls['siteForm']).controls['DisplayName'].value + " created.", "Success!");
        if (this.mode == 1) {
          this.saveResult.emit(response);
          return true;
        }

        if (IsNewWorkOrder && this.permissionPipe.transform(this.actionName.NewWorkOrder)) {
          this.tabopen.ReplaceTab(
            {
              CurrentTabIndex: this.tabCounter,
              newTabInfo: {
                tabId: Tabs.FsLiteWorkOrderCreate,
                params: { data: response },
                tabTitle: 'New Work Order'
              }
            });
        } else {
          setTimeout(() => {
            this.tabopen.DestroyTab(this.tabCounter)
          }, 100)
        }
      }, error => {
        this.destroyTab = false;
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        if (error.error != null) {
          if (error.error.Message.toLowerCase().indexOf("display name is already used for another job site.") > -1) {
            this.toastr.showMultiLineError("Customer " + (<FormGroup>this.newCustomerForm.controls['siteForm']).controls['DisplayName'].value + " failed to create as " + error.error.Message, "Error");
            (<FormGroup>this.newCustomerForm.controls['siteForm']).controls['DisplayName'].setErrors({
              "DuplicateName": true
            });
            this.OnSubmitError(true);
          }
          else if (error.error.Message.toLowerCase().indexOf("display name is already used for another customer.") > -1) {
            this.toastr.showMultiLineError("Customer " + (<FormGroup>this.newCustomerForm.controls['BillingDetailsForm']).controls['DisplayName'].value + " failed to create as " + error.error.Message, "Error");
            (<FormGroup>this.newCustomerForm.controls['BillingDetailsForm']).controls['DisplayName'].setErrors({
              "DuplicateName": true
            });
            this.OnSubmitError(true);
          }
          else {
            this.toastr.showMultiLineError("Customer " + (<FormGroup>this.newCustomerForm.controls['siteForm']).controls['DisplayName'].value + " failed to create as " + error.error.Message, "Error");
          }
        }
        return false;
      })
    }
    else {
      this.destroyTab = false;
      this.OnSubmitError(true);
      return false;
    }
  }

  public CloseTab() {
    this.tabopen.DestroyTab(this.tabCounter);
  }

  private OnSubmitError(IsBillingContactFormValid: boolean) {
    if (!this.newCustomerForm.controls['siteForm'].valid)
      this.ToggleBoxes([SiteNavNewEnum.SiteInformation])
    else if (!this.newCustomerForm.controls['ContactForm'].valid)
      this.ToggleBoxes([SiteNavNewEnum.ContactInformation])
    else if (!this.newCustomerForm.controls['BillingDetailsForm'].valid)
      this.ToggleBoxes([SiteNavNewEnum.BillingDetails])
    else if (!IsBillingContactFormValid)
      this.ToggleBoxes([SiteNavNewEnum.BillingContact])
    this.commonMethods.markFormGroupTouched(this.newCustomerForm)
  }

  private CreateForm() {
    let BillingDetail = new BillingDetailModel();
    let JobSiteDetail = new JobSiteDetailModel();
    let contactModel: ContactInfoModel = new ContactInfoModel();
    this.newCustomerForm = this.frmbuilder.group({
      "ContactForm": this.commonMethods.createFSLiteJobsiteContactForm(contactModel),
      "BillingContactForm": this.commonMethods.createFSLiteBillingContactForm(contactModel),
      "BillingDetailsForm": this.commonMethods.createFSLiteBillingForm(BillingDetail),
      "siteForm": this.commonMethods.createFSLiteJobSiteForm(JobSiteDetail)
    });
    
    if (CommonMethods.CheckNullOrUndefined(this.valueChangeSubscription)) {
      this.valueChangeSubscription = (<FormGroup>this.newCustomerForm.get("siteForm")).valueChanges.subscribe(response => {
        if ((<FormGroup>this.newCustomerForm.get("BillingDetailsForm")).controls["IsDefaultFromJobsite"].value == true) {
          let excludedControls: string[] = ["comment"];
          this.commonMethods.MapAndFillControl(response, (<FormGroup>this.newCustomerForm.get("BillingDetailsForm")), excludedControls);
        }
      });
    }
  }
  //#endregion
}